import React from 'react';
import { EVENT_ID, dispatch } from '../../../../containers/event_manager';
export const ZenModeButton = () => {
    return React.createElement("button", { onClick: () => dispatch(EVENT_ID.ZEN_MODE_TOGGLED) }, "ZEN");
};
